/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowPaintNightTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowPaintNight,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Create and Celebrate!",
    "Paint Night Extravaganza!",
    "Unleash Your Creativity!",
  ],
  title: "Paint Night",
  description: "Organize a fun paint night.",
  longDescription:
    "Gather for a night of creativity! Choose a date, decide on a painting theme, and plan refreshments for the evening!",
  emoji: "🖼",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Paint Night",
          emoji: "🖼",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have paint night?",
          emoji: "📅",
          completeAction: {
            question: "Decide on a painting theme?",
            description: "What theme should we paint for the night?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What painting theme should we choose?",
                emoji: "🎨",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we have during paint night?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍰",
                    },
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What drinks should we serve?",
                      emoji: "🥂",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Time to Create!",
    outroDescription:
      "Your paint night plans are set! Enjoy expressing your creativity!",
  },
};
